@if (open()) {
<div
  class="fixed inset-0 z-[70] flex items-start justify-center bg-black/50 p-4 pt-[12vh] sm:pt-[15vh]"
  role="dialog"
  aria-modal="true"
  aria-labelledby="platform-search-dialog-title"
  (click)="onBackdropClick()"
>
  <div
    class="flex w-full max-w-xl flex-col overflow-hidden rounded border border-gray-200 bg-white shadow-lg"
    role="document"
    (click)="$event.stopPropagation()"
  >
    <div class="border-b border-gray-200 px-4 py-3">
      <div class="flex items-center gap-3">
        <i
          class="bi bi-search shrink-0 text-sm leading-none text-stone-500"
          aria-hidden="true"
        ></i>
        <label class="sr-only" for="platform-search-input">
          Buscar na plataforma
        </label>
        <div class="relative min-w-0 flex-1">
          @if (hasQuery()) {
          <button
            type="button"
            class="absolute inset-y-0 end-0 flex items-center pe-0 text-stone-500 transition hover:text-stone-700 focus:outline-none focus-visible:rounded focus-visible:ring-2 focus-visible:ring-[var(--color-primary-ring)]"
            aria-label="Limpar busca"
            (click)="onClearQuery()"
          >
            <i class="bi bi-x-lg text-sm leading-none" aria-hidden="true"></i>
          </button>
          }
          <input
            #searchInput
            id="platform-search-input"
            type="text"
            role="searchbox"
            autocomplete="off"
            spellcheck="false"
            placeholder="Buscar páginas e registros..."
            class="min-w-0 w-full border-0 bg-transparent text-sm text-stone-900 outline-none placeholder:text-stone-500 focus:ring-0"
            [class.pr-6]="hasQuery()"
            [ngModel]="query()"
            [ngModelOptions]="standaloneNgModel"
            (ngModelChange)="onQueryChange($event)"
          />
        </div>
        <kbd
          class="shrink-0 rounded border border-gray-200 bg-gray-50 px-1.5 py-0.5 text-[10px] font-medium text-gray-500"
          title="Pressione Esc para fechar"
        >
          Esc para fechar
        </kbd>
      </div>
      <h2 id="platform-search-dialog-title" class="sr-only">
        Busca na plataforma
      </h2>
    </div>

    <div #resultsScroll class="max-h-[min(24rem,50vh)] overflow-y-auto p-2">
      @if (results().length === 0) {
      <app-empty-state
        icon="search"
        [message]="
          query().trim()
            ? 'Nenhuma página para esta busca.'
            : 'Nenhuma página disponível para busca.'
        "
      />
      } @else {
      <p
        class="px-3 pb-1 text-[11px] font-medium uppercase tracking-wide text-gray-500"
      >
        Páginas
      </p>
      <ul role="listbox" aria-label="Resultados da busca">
        @for (entry of results(); track entry.id; let index = $index) {
        <li
          role="option"
          [attr.aria-selected]="activeIndex() === index"
          [attr.data-search-index]="index"
        >
          <button
            type="button"
            class="flex w-full items-center gap-3 rounded px-3 py-2.5 text-left transition focus:outline-none"
            [ngClass]="{
              'bg-[var(--color-primary-soft)] text-[var(--color-primary)]':
                activeIndex() === index,
              'text-gray-800 hover:bg-gray-50': activeIndex() !== index,
            }"
            (mouseenter)="onResultMouseEnter(index)"
            (click)="selectEntry(entry)"
          >
            <span
              class="inline-flex size-8 shrink-0 items-center justify-center rounded bg-gray-100 text-gray-600"
              [ngClass]="{
                'bg-white/70 text-[var(--color-primary)]':
                  activeIndex() === index,
              }"
              aria-hidden="true"
            >
              <i
                [class]="'bi bi-' + entry.iconClass + ' text-base leading-none'"
                aria-hidden="true"
              ></i>
            </span>
            <span class="min-w-0 flex-1">
              <span class="block truncate text-sm font-medium">
                {{ entry.label }}
              </span>
              @if (entry.groupLabel) {
              <span class="mt-0.5 block truncate text-xs text-gray-500">
                {{ entry.groupLabel }}
              </span>
              }
            </span>
            <i
              class="bi bi-arrow-return-left shrink-0 text-xs text-gray-400"
              aria-hidden="true"
            ></i>
          </button>
        </li>
        }
      </ul>
      }
    </div>

    <div
      class="flex flex-col gap-2 border-t border-gray-200 px-4 py-2 text-[11px] text-gray-500 sm:flex-row sm:items-center sm:justify-between"
    >
      <span>
        @if (showFullResultsCta()) { ↑ ↓ navegam páginas · Enter abre ·
        Shift+Enter busca na base } @else { ↑ ↓ navegam páginas · Enter abre }
      </span>
      <div class="flex items-center gap-3">
        <span>{{ results().length }} página(s)</span>
        @if (showFullResultsCta()) {
        <button
          type="button"
          class="inline-flex items-center gap-1 rounded border border-[var(--color-primary)] px-2 py-1 text-[11px] font-medium text-[var(--color-primary)] transition hover:bg-[var(--color-primary-soft)] focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-ring)]"
          (click)="openFullResults()"
        >
          Ver resultados
          <i
            class="bi bi-arrow-right text-xs leading-none"
            aria-hidden="true"
          ></i>
        </button>
        }
      </div>
    </div>
  </div>
</div>
}
